export default {
	drawer: {
		imprint: '@:common.imprint',
		termsAndPrivacy: 'AGB {amp} Datenschutz',
		changelog: 'Änderungshistorie',
	},
}
